const normalizeOwnershipTotal = (value) => (
    Number.isInteger(value) ? value : Number(value.toFixed(2))
);

export const calculateIndividualShareholderOwnershipTotal = (individuals = []) => {
    if (!Array.isArray(individuals)) {
        return 0;
    }

    const total = individuals.reduce((sum, individual) => {
        if (individual?.isShareHolder !== true) {
            return sum;
        }

        const percentOwner = parseFloat(individual?.percentOwner);
        return sum + (Number.isNaN(percentOwner) ? 0 : percentOwner);
    }, 0);

    return normalizeOwnershipTotal(total);
};

export const getIndividualShareholderOwnershipError = (individuals = []) => {
    const total = calculateIndividualShareholderOwnershipTotal(individuals);
    if (total > 100) {
        return `Total ownership percentage for individual shareholders cannot exceed 100%. Current total: ${total}%.`;
    }
    return null;
};
